import { Suspense, lazy } from "react";
import UXloader from "../components/layouts/UXloader";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<UXloader />}>
      <Component {...props} />
    </Suspense>
  );
};

// COMPONENTS
export const Products = Loadable(lazy(() => import("../components/products")));
export const Dashboard = Loadable(lazy(() => import("../components/dashboard")));
export const TestReport = Loadable(lazy(() => import("../components/test-report")));
export const TestCreation = Loadable(lazy(() => import("../components/test-creation")));
export const NewTest = Loadable(lazy(() => import("../components/test-creation/NewTest")));
export const TestPreview = Loadable(lazy(() => import("../components/test-preview")));
export const Template = Loadable(lazy(() => import("../components/templates/Template")));
export const AnalysisSpace = Loadable(lazy(() => import("../components/projectanalysis")));
export const Response = Loadable(lazy(() => import("../components/testerview/Index")));
export const EndScreen = Loadable(lazy(() => import("../components/testerview/EndScreen")));
export const StartScreen = Loadable(lazy(() => import("../components/testerview/StartScreen")));
export const BrowserTest = Loadable(lazy(() => import("../components/browser-test")));
export const EmbedViewer = Loadable(lazy(() => import("../components/embed-viewer/EmbedViewer")));
export const EmbedViewerTreeTask = Loadable(lazy(() => import("../components/embed-viewer/TreeTask")));
export const EmbedViewerCardSort = Loadable(lazy(() => import("../components/embed-viewer/cardsort/CardSort")));
export const DashboardModerated = Loadable(lazy(() => import("../components/dashboard-moderated")));
export const ModeratedReport = Loadable(lazy(() => import("../components/dashboard-moderated/Report")));
export const ModeratedSchedules = Loadable(lazy(() => import("../components/dashboard-moderated/AllSchedules")));
export const ModeratedScheduler = Loadable(lazy(() => import("../components/dashboard-moderated/SessionScheduler")));
export const ModeratedSlotBooking = Loadable(lazy(() => import("../components/dashboard-moderated/ParticipantSlotBooking")));
export const ModeratedEventEditor = Loadable(lazy(() => import("../components/dashboard-moderated/EventEditor")));
export const AiInterviewLanding = Loadable(lazy(() => import("../components/dashboard-moderated/AiInterviewLanding")));
export const Heatmap = Loadable(lazy(() => import("../components/test-report/Heatmap")));
export const Plans = Loadable(lazy(() => import("../components/subscriptions/Plans")));
export const UpgradePlan = Loadable(lazy(() => import("../components/subscriptions/UpgradePlan")));
export const TopUp = Loadable(lazy(() => import("../components/subscriptions/TopUp")));
export const NavigationTree = Loadable(lazy(() => import("../components/test-report/NavigationTree")));
export const VideoPlayer = Loadable(lazy(() => import("../components/test-report/VideoPlayer")));
export const ModeratedVideoPlayer = Loadable(lazy(() => import("../components/dashboard-moderated/ModeratedVideoPlayer")));

// ERROR
export const Error404 = Loadable(lazy(() => import("../components/layouts/Error404")));

// User
export const EditProfile = Loadable(lazy(() => import("../components/user/EditProfile")));
export const Billings = Loadable(lazy(() => import("../components/user/Billings")));
export const Subscriptions = Loadable(lazy(() => import("../components/user/Subscriptions")));
export const Integrations = Loadable(lazy(() => import("../components/user/Integrations")));
export const GlobalSettings = Loadable(lazy(() => import("../components/user/GlobalSettings")));
export const UserOnboarding = Loadable(lazy(() => import("../components/user/UserOnboarding")));
export const People = Loadable(lazy(() => import("../components/organization/People")));
export const Organization = Loadable(lazy(() => import("../components/organization/Organization")));
export const Workspace = Loadable(lazy(() => import("../components/organization/Workspace")));
export const WorkspaceSwitch = Loadable(lazy(() => import("../components/organization/WorkspaceSwitch")));
export const WorkspaceInvitation = Loadable(lazy(() => import("../components/organization/WorkspaceInvitation")));

// Client Contacts (Participant Management)
export const ParticipantsList = Loadable(lazy(() => import("../components/client-contacts")));
export const Projects = Loadable(lazy(() => import("../components/projects")));
export const ProjectDetail = Loadable(lazy(() => import("../components/projects/detail")));
export const AllStudies = Loadable(lazy(() => import("../components/studies")));
export const PublicFilesView = Loadable(lazy(() => import("../components/projects/share/PublicFilesView")));

// Manage Tags
export const TagDetail = Loadable(lazy(() => import("../components/manage-tags/TagDetail")));
export const ManageTagsPage = Loadable(lazy(() => import("../components/manage-tags/ManageTagsPage")));

// Toolkit
export const ToolkitDashboard = Loadable(lazy(() => import("../components/toolkit/components/dashboard")));
export const ToolkitTestCreation = Loadable(lazy(() => import("../components/toolkit/components/test-creation")));
export const ToolkitTestCreationInit = Loadable(lazy(() => import("../components/toolkit/components/test-creation/TestInit")));
export const ToolkitReport = Loadable(lazy(() => import("../components/toolkit/components/test-report/")));
export const ToolkitTesterview = Loadable(lazy(() => import("../components/toolkit/components/testerview")));
export const ToolkitReportPieTree = Loadable(lazy(() => import("../components/toolkit/components/test-report/PieTreeIndex")));
export const SimilarityMatrix = Loadable(lazy(() => import("../components/toolkit/components/test-report/SimilarityMatrixIndex")));
export const ToolkitReportDendrogram = Loadable(lazy(() => import("../components/toolkit/components/test-report/dendrogram/NewPage")));
